import { connectNetsByDescriptor, disconnectPinsByDescriptor } from "../document-actions";
/**
 * Applies a nets action by adding or removing connections between components
 * @param action The nets action to apply
 * @param dependencies The dependencies needed to apply the action
 * @returns A promise that resolves to the result of applying the action
 */
export function applyNetsAction(action, document, actionContext) {
    for (const net of action) {
        if (net.action === "disconnect" && net.pins.length > 0) {
            disconnectPinsByDescriptor(document, net.pins);
        }
    }
    const netConnections = action.filter((net) => net.action === "connect" && net.pins.length >= 2);
    if (netConnections.length) {
        connectNetsByDescriptor(document, netConnections, actionContext);
    }
    // NOTE: the previous version of `applyNetsAction` would also return "touchedElementUids", but
    // this was only used for updating the user's selection post-action. The right place to do this
    // going forward will as a function call from inside this code, independent of the UI.
    return {
        netsUpdated: action.map((n) => ({
            ...n,
            pins: n.pins.map((p) => ({ componentDesignator: p.component, pinDesignator: p.pinDesignator })),
        })),
    };
}
//# sourceMappingURL=applyNetsAction.js.map